import React from 'react';
import ContentRouter from '../../routers/contentRouter';

const Content = props => {
    return <ContentRouter />;
};

export default Content;
